<template>
    <div class='ActiveType'>
        <!-- 活动类型选择控件 -->
        <el-dialog title="活动类型" :visible.sync='activeType' width="721px" :before-close="handleClose">
            <el-radio-group v-model="type" class='type-list'>
                <el-radio :label="1">
                    <div class='item'>
                        <p class="name">阅读助力</p>
                    <p class='desc'>适用于吸引用户流量。</p>
                    </div>
                </el-radio>
                <el-radio :label="2">
                   <div class='item'>
                        <p class="name">公众号助力</p>
                        <p class='desc'>适用于引流到公众号，为公众号新增粉丝。</p>
                   </div>
                </el-radio>
                <el-radio :label="3">
                   <div class='item'>                     
                        <p class="name">砍价助力</p>
                        <p class='desc'>适用于商品砍价购买，吸引用户购买商品。</p>
                   </div>
                </el-radio>
            </el-radio-group>
            <span slot="footer" class='dialog-footer'>
                <el-button @click='handleClose'>取 消</el-button>
                <el-button type="primary" @click='goto'>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'ActiveType',
    props: ['activeType'],
    data() {
        return {
            type: 1
        }
    },
    methods: {
        goto() {    // 确定后前往新页面
            this.$router.push({name: 'TaskActivityEdit',query:{'type': this.type}})
        },
        handleClose() { // 关闭页面
            this.$emit('closeActiveType',false)
        }

    }
}
</script>

<style lang='scss' type='text/scss'>
.ActiveType {
    .el-radio__inner {
        display: none
    }
    .type-list {
        display: flex;
        flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        .is-checked {
            .item {
                border: solid 1px #409EFF;
            }
        }
        .item {
            padding: 15px;
            width: 200px;
            height: 100px;
            box-sizing: border-box;
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            border: solid 1px #E4E7ED;
            // background: url('../../../../commom/images/toolmgt/radio.png') no-repeat left top;
            background-size: 30px;
            .name {
                margin-bottom: 15px;
                color: #303133;
                text-align: center;
            }
            .desc {
                white-space: initial;
                text-align: center;
                line-height: 20px;
                color: #909399;
            }
        }
    }
   
}
</style>